<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-add="false"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
import { getLabelByCode } from '@/utils/util'
export default {
  name: 'VehicleTrace',
  components: {
    TableWrapper
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/trace',
      action: '',
      garages: this.loadGarages()
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '出入日期', width: '190px', options: {
            shortcuts: [
              {
                text: '一周',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                  return [start, end]
                }
              },
              {
                text: '一个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                  return [start, end]
                }
              },
              {
                text: '三个月',
                value() {
                  const end = new Date()
                  const start = new Date()
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                  return [start, end]
                }
              }
            ]
          }, placeholder: '请选择出入日期...', type: 'dateranger' },
          { label: '绑定车库', placeholder: '请选择绑定车库...', name: 'parkingId', width: '160px', type: 'select', options: this.garages },
          { label: '车辆编号', placeholder: '请输入车辆编号...', name: 'planetNumber', width: '120px', type: 'input' },
          { label: '用户手机', placeholder: '请输入用户手机...', name: 'mobile', width: '140px', type: 'input' },
          { label: '绑定用户', placeholder: '请输入绑定用户...', name: 'user', width: '120px', type: 'input' },
          { label: '开门方式', placeholder: '请选择开门方式...', name: 'openType', width: '190px', type: 'select', hidden: true, options: this.$config.doorOpenTypes },
          { label: '远程开门操作人员', placeholder: '请选择远程开门操作人员...', name: 'openOperator', width: '190px', type: 'input' },
          { label: '事件类型', placeholder: '请选择事件类型...', name: 'status', width: '160px', type: 'select', hidden: true, options: [
            { label: '正常', value: 0 },
            { label: '异常', value: 1 }]
          }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '车库', align: 'left', key: 'parking', sortable: true, type: 'select', options: this.garages, ellipsis: true, tooltip: true },
        { title: '终端', align: 'center', key: 'agent', sortable: true, ellipsis: true, tooltip: true },
        { title: '用户', align: 'center', key: 'user', sortable: true, ellipsis: true, tooltip: true },
        { title: '车辆编号', align: 'center', key: 'planet_number', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 0 ? 'green' : '#4556FE' }
            }, params.row.planet_number || '---')
          }
        },
        { title: '类型', align: 'center', key: 'log_type', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.log_type === 0 ? 'green' : '#4556FE' }
            }, params.row.log_type === 0 ? '进入' : params.row.log_type === 1 ? '离开' : params.row.log_type === 2 ? '异常' : '---')
          }
        },
        { title: '开门方式', align: 'center', key: 'open_type', sortable: true, width: 120, ellipsis: true,
          render: (h, params) => {
            return h('span', {}, getLabelByCode(params.row.open_type, this.$config.doorOpenTypes))
          }
        },
        { title: '远程开门操作人员', align: 'center', key: 'open_operator', sortable: true, width: 120, ellipsis: true},
        { title: '状态', align: 'center', key: 'status', sortable: true, width: 120, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.status === 0 ? 'green' : 'red' }
            }, params.row.status === 0 ? '正常' : '异常') // (params.row.type === 2 ? '出库' : '异常'))
          }
        },
        { title: '发生时间', align: 'center', key: 'record_time', sortable: true, width: 160, ellipsis: true, tooltip: true }
      ]
    }
  },
  methods: {
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    }
  }
}
</script>

